import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rpt-form',
  templateUrl: './rpt-form.component.html',
  styleUrls: ['./rpt-form.component.css']
})
export class RptFormComponent implements OnInit {
  title="Reports"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/view/rpt-form/rpt-form.component.ts